import { mapPaymentError, mapPaymentFormError, PAYMENT_CONSTANTS } from '../constants/PaymentConstants';

const getPaymentDetails = (state) => state.payment;

// Error response could either coming from rm-api or metroid backend.
// Metroid's error response respects { code, code_details, message }.
// Note: ZE-UI is a general error code - the actual error type is in code_details
const PaymentSelectors = {
  makeIsPaymentValid: (state) => getPaymentDetails(state).chargeAndActivateListing.isPaymentValid === true,
  makeDefaultPaymentMethodSuccess: (state) =>
    getPaymentDetails(state).chargeAndActivateListing.defaultPaymentMethodSuccess,
  makeDefaultPaymentMethod: (state) => getPaymentDetails(state).chargeAndActivateListing.defaultPaymentMethod,
  makePrice: (state) => getPaymentDetails(state).details.price,
  makeHasError: (state) => {
    const { error } = getPaymentDetails(state).capture;
    return error != null;
  },
  makeIsInMaintenanceMode: (state) => {
    const { error } = getPaymentDetails(state).capture;
    return error && error.code === PAYMENT_CONSTANTS.CAPTURE.INITIATE.ERROR.METROID_MAINTENANCE_MODE;
  },
  makeErrorMessage: (state) => {
    const { error } = getPaymentDetails(state).capture;
    if (!error) {
      return '';
    }
    // Use the new utility function that properly handles code_details
    const message = mapPaymentError(error);
    return message;
  },
  makeFormErrorMessage: (state) => {
    const { error } = getPaymentDetails(state).capture;
    if (!error) {
      return '';
    }
    // Use the new utility function that properly handles form-specific errors
    const message = mapPaymentFormError(error);
    return message;
  },
};

export default PaymentSelectors;
